export type RefetchIntervalOption = number | false;

interface QueryStatusLike {
  readonly state: {
    readonly status: 'error' | 'pending' | 'success';
  };
}

export function refetchIntervalWhileHealthy(
  interval: RefetchIntervalOption,
): RefetchIntervalOption | ((query: QueryStatusLike) => RefetchIntervalOption) {
  if (interval === false) return false;
  return (query) => (query.state.status === 'error' ? false : interval);
}
